/** Resume param on the standalone journey URL an embed sends the top window to:
 * the one-time code the parked journey session is redeemed with. */
export const EP_SSO_RESUME_PARAM = 'ep_sso_resume'

/** Our own transport params never survive a hop; matched as a prefix so a
 * forgotten one can never be replayed or swallowed as a context value. */
export const SSO_PARAM_PREFIX = 'ep_sso_'
